<div class="table-container" *ngIf="pessoaId">
    <div id="mainDiv">
        <p-dropdown [options]="tipoDeTransacao" [(ngModel)]="transacaoSelecionada" optionLabel="label"
            [placeholder]="placeholders.tipo_transacao" />
        <div class="p-iconField">
            <p-iconField iconPosition="right">
                <p-inputIcon class="icon-search-button" styleClass=" pi pi-search" (click)="search()" />
                <input class="input-field" [(ngModel)]="searchCodigo" (keydown)="onKeyDown($event)" type="text"
                    pInputText [placeholder]="placeholders.pesquisar_codigo" />
            </p-iconField>
        </div>

        <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"
            [placeholder]="placeholders.pesquisar_data" />
        <p-button styleClass="button-adicionar-x" [label]="botoes.buscar" icon="pi pi-search" (click)="search()" />
    </div>
    <p-table [value]="movimentacao" class="table-style" [customSort]="true" (sortFunction)="customSort($event)">
        <ng-template class="ct-tr" pTemplate="header">
            <tr>
                <th pSortableColumn="id"># <p-sortIcon field="id" /> </th>
                <th pSortableColumn="codigoMovimento">{{headers.codigo_movimento}} <p-sortIcon field="codigoMovimento" /> </th>
                <th pSortableColumn="tipoDeTransacao">{{headers.tipo_transacao}} <p-sortIcon field="tipoDeTransacao" /> </th>
                <th pSortableColumn="valor">{{headers.valor_total}} <p-sortIcon field="valor" /> </th>
                <th>{{headers.moeda_da_conta}} </th>
                <th>{{headers.moeda_da_conta_destino}} </th>
                <th pSortableColumn="criadoEm">{{headers.data_inclusao}} <p-sortIcon field="criadoEm" /> </th>
                <th>{{headers.acoes}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-movimentacao>
            <tr>
                <td>{{ movimentacao.id }}</td>
                <td>{{ movimentacao.codigoMovimento }}</td>
                <td>{{ traduzirTipoTransacao(movimentacao.tipoDeTransacao) }}</td>
                <td>{{ movimentacao.valor }}</td>
                <td>{{ movimentacao.moedaDaConta }}</td>
                <td>{{ movimentacao.moedaDaContaDestino }}</td>
                <td>{{ movimentacao.criadoEm }}</td>
                <td>
                    <div class="table-actions">
                        <i class="pi pi-eye pi-download" [pTooltip]="tooltips.relatorio_pdf" tooltipPosition="top"></i>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="pagination-container">
        <p-paginator (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [showFirstLastIcon]="true">
        </p-paginator>

        <span class="mx-1 text-color">{{texts.itens_por_pagina}} </span>
        <p-dropdown [options]="options" optionLabel="label" optionValue="value" [(ngModel)]="rows"
            (ngModelChange)="onRowsPerPageChange()"></p-dropdown>
    </div>
</div>
